import * as _ from 'lodash';
import {Concept} from '../../shared/models/concept';
import {Action} from '@ngrx/store';
import {conceptLoadActionTypes, LoadConceptSuccessAction} from '../actions/concept-subcription-load';

export interface ConceptsBySubscriptionState {
  array: Concept[];
}

const initialState: ConceptsBySubscriptionState = {
  array: []
};

export function ConceptsBySubscriptionReducer(state: ConceptsBySubscriptionState = initialState, action: Action): ConceptsBySubscriptionState {
  switch (action.type) {
    case conceptLoadActionTypes.Load_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case conceptLoadActionTypes.Load_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ConceptsBySubscriptionState, action: LoadConceptSuccessAction): ConceptsBySubscriptionState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: ConceptsBySubscriptionState): ConceptsBySubscriptionState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}


export const conceptsBySubscriptionSelectors = {
  array: (state: ConceptsBySubscriptionState) => _.get(state, 'array', [])
};
